package pl.finn.forms.ezw

import io.kvision.core.Placement
import io.kvision.core.TooltipOptions
import io.kvision.core.enableTooltip
import io.kvision.core.onEvent
import io.kvision.form.FormHorizontalRatio
import io.kvision.form.check.CheckBox
import io.kvision.form.check.RadioGroup
import io.kvision.form.select.Select
import io.kvision.form.select.selectOption
import io.kvision.form.text.ImaskOptions
import io.kvision.form.text.PatternMask
import io.kvision.form.text.Text
import io.kvision.form.time.DateTime
import io.kvision.html.Div
import io.kvision.panel.FieldsetPanel
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.common.BlockList
import pl.finn.forms.fk02.DynamicFieldsValidator
import pl.finn.forms.utils.model.Util
import pl.finn.forms.utils.validation.ValidationUtils


class EzwBlocks(dfv: DynamicFieldsValidator, components: EzwComponents, ezwBL: BlockList) {

  private val dynamicFieldsValidator = dfv
  private val ezwComponents = components
  private val ezwBlockList = ezwBL

  val blokAZmianaRachunku: (ZmianaRachunku, String?) -> FieldsetPanel = { blokAZmianaRachunku, elementsName ->
    FieldsetPanel(elementsName).apply {
      add(dynamicFieldsValidator.add( //Text: NrRachunkuPLPoprzedni "Poprzedni numer rachunku bankowego wierzyciela"
        Text(
          value = blokAZmianaRachunku.nrRachunkuPLPoprzedni,
          label = "Poprzedni numer rachunku bankowego wierzyciela"
        ).apply {
          onEvent {
            change = {
              blokAZmianaRachunku.nrRachunkuPLPoprzedni = self.value
            }
          }
          enableTooltip(
            TooltipOptions(
              "CC-AAAA-AAAA-BBBB-BBBB-BBBB-BBBB<br>gdzie:<br>CC to suma kontrolna (2 cyfry) <br> AAAA-AAAA to numer rozliczeniowy jednostki organizacyjnej banku (8 cyfr) <br/> BBBB-BBBB-BBBB-BBBB to numer rachunku klienta w banku (16 cyfr).",
              rich = true,
              placement = Placement.BOTTOM
            )
          )
          maskOptions = ImaskOptions(
            pattern = PatternMask(
              pattern = "00{ }0000{ }0000{ }0000{ }0000{ }0000{ }0000",
              lazy = false,
              eager = null,
              placeholderChar = '_',
              definitions = null,
              blocks = null,
            )
          )
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (ValidationUtils.validateAccountNumber(elem) == null && (!elem.isNullOrEmpty() && !elem.isBlank())) },
        { elem -> (ValidationUtils.validateAccountNumber(elem) ?: POLE_WYMAGANE) }
      ))
      add(dynamicFieldsValidator.add( //Text: NrRachunkuPLNowy "Nowy numer rachunku bankowego wierzyciela"
        Text(
          value = blokAZmianaRachunku.nrRachunkuPLNowy,
          label = "Nowy numer rachunku bankowego wierzyciela"
        ).apply {
          onEvent {
            change = {
              blokAZmianaRachunku.nrRachunkuPLNowy = self.value
            }
          }
          enableTooltip(
            TooltipOptions(
              "CC-AAAA-AAAA-BBBB-BBBB-BBBB-BBBB<br>gdzie:<br>CC to suma kontrolna (2 cyfry) <br> AAAA-AAAA to numer rozliczeniowy jednostki organizacyjnej banku (8 cyfr) <br/> BBBB-BBBB-BBBB-BBBB to numer rachunku klienta w banku (16 cyfr).",
              rich = true,
              placement = Placement.BOTTOM
            )
          )
          maskOptions = ImaskOptions(
            pattern = PatternMask(
              pattern = "00{ }0000{ }0000{ }0000{ }0000{ }0000{ }0000",
              lazy = false,
              eager = null,
              placeholderChar = '_',
              definitions = null,
              blocks = null,
            )
          )
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (ValidationUtils.validateAccountNumber(elem) == null && (!elem.isNullOrEmpty() && !elem.isBlank())) },
        { elem -> (ValidationUtils.validateAccountNumber(elem) ?: POLE_WYMAGANE) }
      ))
    }
  }

  val blokC: (BlokC, String?) -> FieldsetPanel = { blokC , elementsName ->
    FieldsetPanel(elementsName).apply { //InformacjaODokumencie
      add(ezwComponents.dateField( //Text: DataWystawienia "Data wystawienia tytułu wykonawczego/zarządzenia zabezpieczenia"
        field = blokC.dataWystawienia,
        label = "Data wystawienia tytułu wykonawczego/zarządzenia zabezpieczenia")
      )
      add(dynamicFieldsValidator.add( //Text: Sygnatura "Dotyczy tytułu wykonawczego/zarządzenia zabezpieczenia o numerze:"
        Text(
          value = blokC.sygnatura,
          label = "Dotyczy tytułu wykonawczego/zarządzenia zabezpieczenia o numerze:"
        ).apply {
          onEvent {
            change = {
              blokC.sygnatura = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      add( //Text: NrReferencyjny "Numer referencyjny tytułu wykonawczego/zarządzenia zabezpieczenia" (opcjonalny)
        Text(
          value = blokC.nrReferencyjny,
          label = "Numer referencyjny tytułu wykonawczego/zarządzenia zabezpieczenia"
        ).apply {
          onEvent {
            change = {
              blokC.nrReferencyjny = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
    }
  }

  val blokD: (BlokD, String?) -> FieldsetPanel = { blokD , elementsName ->
    FieldsetPanel(elementsName).apply {
      var blokDzawartoscOpcjonalna = Div().apply {
        visible = blokD.posiadaBlok

        var blokDWewnetrznyLista = ezwBlockList.generateModifiableList(
          blokD.blokDWewnetrzny,
          blokDWewnetrzny,
          :: BlokDWewnetrzny,
          "Zmiany wysokosci",
          { iter -> "D$iter." }
        )
        add(blokDWewnetrznyLista)
        add(//Text: uzupelnienie "Uzupelnienie" //opcjonalne
          Text(
            value = blokD.uzupelnienie,
            label = "Uzupelnienie"
          ).apply {
            onEvent {
              change = {
                blokD.uzupelnienie = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          }
        )
      }
      add(ezwComponents.checkBoxPosiadaBlok(blok = blokD, blokDiv = blokDzawartoscOpcjonalna, "Uzupełnij Blok D"))
      add(blokDzawartoscOpcjonalna)
    }
  }

  val blokDWewnetrzny: (BlokDWewnetrzny, String?) -> FieldsetPanel = { blokDWewnetrzny , elementsName ->
    FieldsetPanel(elementsName).apply {
      var wyegzekwowanie = Div().apply {
        visible = blokDWewnetrzny.powodZmianyWysokosciNaleznosciLubKosztowUpomnienia == "Wyegzekwowanie"
        add(FieldsetPanel("Wyegzekwowania należności pieniężnej przez inny organ egzekucyjny").apply { //Wyegzekwowanie
          add(dynamicFieldsValidator.add( //Text: nazwaOE "Nazwa Organu Egzekucyjnego"
            Text(
              value = blokDWewnetrzny.wyegzekwowanie.nazwaOE,
              label = "Nazwa Organu Egzekucyjnego"
            ).apply {
              onEvent {
                change = {
                  blokDWewnetrzny.wyegzekwowanie.nazwaOE = self.value
                }
              }
              styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
              flabel.addCssClass("required-label")
            },
            { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
            POLE_WYMAGANE
          ))
          add(ezwComponents.fieldsetPanelDataOkres(
            field = blokDWewnetrzny.wyegzekwowanie.dataOkresPowstaniaNaleznosci,
            label = "Data/okres powstania należności pieniężnej"
          ))
          add(ezwComponents.dateField(//Text: dataWyegzekwowania "Data wyegzekwowania należności pieniężnych"
            field = blokDWewnetrzny.wyegzekwowanie.dataWyegzekwowania,
            label = "Data wyegzekwowania należności pieniężnych")
          )
          add(ezwComponents.amountField(//Text: wysokoscPozostalejNaleznosci "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.wyegzekwowanie.wysokoscPozostalejNaleznosci,
            label = "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNaDzien "Wysokość odsetek na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.wyegzekwowanie.wysokoscOdsetekNaDzien,
            label = "Wysokość odsetek na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscKosztow "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.wyegzekwowanie.wysokoscKosztow,
            label = "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia",
            required = false
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNiezaplacenie "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej w terminie naliczonych na dzień wystawienia tytułu wykonawczego od zmniejszonej w wyniku wyegzekwowania wysokości należności pieniężnej"
            field = blokDWewnetrzny.wyegzekwowanie.wysokoscOdsetekNiezaplacenie,
            label = "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej w terminie naliczonych na dzień wystawienia tytułu wykonawczego od zmniejszonej w wyniku wyegzekwowania wysokości należności pieniężnej"
          ))
        })
      }
      var korekta = Div().apply {
        visible = blokDWewnetrzny.powodZmianyWysokosciNaleznosciLubKosztowUpomnienia == "Korekta"
        add(FieldsetPanel("Korekty deklaracji/zeznania powodującej zmniejszenie wysokości należności pieniężnej").apply { //Korekta
          add(ezwComponents.fieldsetPanelDataOkres(
            field = blokDWewnetrzny.korekta.dataOkresPowstaniaNaleznosci,
            label = "Data/okres powstania należności pieniężnej"
          ))
          add(ezwComponents.dateField(//Text: dataKorekty "Data dokonania korekty"
            field = blokDWewnetrzny.korekta.dataKorekty,
            label = "Data dokonania korekty"
          ))
          add(ezwComponents.amountField(//Text: wysokoscPozostalejNaleznosci "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.korekta.wysokoscPozostalejNaleznosci,
            label = "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNaDzien "Wysokość odsetek na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.korekta.wysokoscOdsetekNaDzien,
            label = "Wysokość odsetek na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscKosztow "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.korekta.wysokoscKosztow,
            label = "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia",
            required = false
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNiezaplacenie "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej na dzień wystawienia tytułu wykonawczego od zmniejszonej wysokości należności pieniężnej"
            field = blokDWewnetrzny.korekta.wysokoscOdsetekNiezaplacenie,
            label = "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej na dzień wystawienia tytułu wykonawczego od zmniejszonej wysokości należności pieniężnej"
          ))
        })
      }
      var przedawnienie = Div().apply {
        visible = blokDWewnetrzny.powodZmianyWysokosciNaleznosciLubKosztowUpomnienia == "Przedawnienie"
        add(FieldsetPanel("Przedawnienia należności pieniężnej").apply {//Przedawnienie
          add(ezwComponents.fieldsetPanelDataOkres(
            field = blokDWewnetrzny.przedawnienie.dataOkresPowstaniaNaleznosci,
            label = "Data/okres powstania należności pieniężnej"
          ))
          add(ezwComponents.dateField(//Text: dataPrzedawnienia "Data przedawnienia"
            field = blokDWewnetrzny.przedawnienie.dataPrzedawnienia,
            label = "Data przedawnienia",
            required = false
          ))
          add(ezwComponents.amountField(//Text: wysokoscKosztow "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.przedawnienie.wysokoscKosztow,
            label = "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia",
            required = false
          ))
        })
      }
      var zaplata = Div().apply {
        visible = blokDWewnetrzny.powodZmianyWysokosciNaleznosciLubKosztowUpomnienia == "Zaplata"
        add(FieldsetPanel("Zapłaty wierzycielowi należności pieniężnej").apply {//Zaplata
          add(ezwComponents.fieldsetPanelDataOkres(
            field = blokDWewnetrzny.zaplata.dataOkresPowstaniaNaleznosci,
            label = "Data/okres powstania należności pieniężnej"
          ))
          add(ezwComponents.dateField(//Text: dataUzyskania "Data uzyskania należności pieniężnej"
            field = blokDWewnetrzny.zaplata.dataUzyskania,
            label = "Data uzyskania należności pieniężnej"
          ))
          add(ezwComponents.amountField(//Text: wysokoscUzyskanejNaleznosci "Wysokość uzyskanej należności pieniężnej"
            field = blokDWewnetrzny.zaplata.wysokoscUzyskanejNaleznosci,
            label = "Wysokość uzyskanej należności pieniężnej"
          ))
          add(ezwComponents.amountField(//Text: wysokoscUzyskanychOdsetek "Wysokość uzyskanych odsetek z tytułu niezapłacenia należności pieniężnej na dzień wystawienia tytułu wykonawczego"
            field = blokDWewnetrzny.zaplata.wysokoscUzyskanychOdsetek,
            label = "Wysokość uzyskanych odsetek z tytułu niezapłacenia należności pieniężnej na dzień wystawienia tytułu wykonawczego"
          ))
          add(ezwComponents.amountField(//Text: wysokoscUzyskanychKosztow "Wysokość uzyskanych kosztów upomnienia"
            field = blokDWewnetrzny.zaplata.wysokoscUzyskanychKosztow,
            label = "Wysokość uzyskanych kosztów upomnienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscPozostalejNaleznosci "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.zaplata.wysokoscPozostalejNaleznosci,
            label = "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNaDzien "Wysokość odsetek na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.zaplata.wysokoscOdsetekNaDzien,
            label = "Wysokość odsetek na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscKosztow "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.zaplata.wysokoscKosztow,
            label = "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia",
            required = false
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNiezaplacenie "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej w terminie naliczonych na dzień wystawienia tytułu wykonawczego od zmniejszonej w wyniku zapłaty wysokości należności pieniężnej"
            field = blokDWewnetrzny.zaplata.wysokoscOdsetekNiezaplacenie,
            label = "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej w terminie naliczonych na dzień wystawienia tytułu wykonawczego od zmniejszonej w wyniku zapłaty wysokości należności pieniężnej"
          ))
          add(dynamicFieldsValidator.add( //Select: podmiotZaplaty "Informacja o podmiocie, który dokonał zapłaty:" // listOfEntityTypesInformationsAboutentityThatMadePayment
            Select(
              value = blokDWewnetrzny.zaplata.podmiotZaplaty,
              label = "Informacja o podmiocie, który dokonał zapłaty:"
            ).apply {
              emptyOption = true
              onEvent {
                change = {
                  blokDWewnetrzny.zaplata.podmiotZaplaty = self.value
                }
              }
              for ((key, value) in EzwData.listOfEntityTypesInformationsAboutentityThatMadePayment) {
                selectOption(value = key.toString(), label = value)
                liveSearch = true
              }
              styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
              flabel.addCssClass("required-label")
            },
            { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
            POLE_WYMAGANE
          ))
        })
      }
      var inneZdarzenie = Div().apply {
        visible = blokDWewnetrzny.powodZmianyWysokosciNaleznosciLubKosztowUpomnienia == "InneZdarzenie"
        add(FieldsetPanel("Inne zdarzenia skutkujące zmniejszeniem wysokości należności").apply {//InneZdarzenie
          add(dynamicFieldsValidator.add( //Text: opisZdarzenia "Opis zdarzenia"
            Text(
              value = blokDWewnetrzny.inneZdarzenie.opisZdarzenia,
              label = "Opis zdarzenia"
            ).apply {
              onEvent {
                change = {
                  blokDWewnetrzny.inneZdarzenie.opisZdarzenia = self.value
                }
              }
              styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
              flabel.addCssClass("required-label")
            },
            { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
            POLE_WYMAGANE
          ))
          add(ezwComponents.dateField(//Text: dataZdarzenia "Data powstania zdarzenia"
            field = blokDWewnetrzny.inneZdarzenie.dataZdarzenia,
            label = "Data powstania zdarzenia"
          ))
          add(ezwComponents.fieldsetPanelDataOkres(
            field = blokDWewnetrzny.inneZdarzenie.dataOkresPowstaniaNaleznosci,
            label = "Data/okres powstania należności pieniężnej"
          ))
          add(ezwComponents.amountField(//Text: wysokoscPozostalejNaleznosci "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.inneZdarzenie.wysokoscPozostalejNaleznosci,
            label = "Wysokość należności pieniężnej pozostałej do wyegzekwowania na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNaDzien "Wysokość odsetek pozostałych do wyegzekwowania na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.inneZdarzenie.wysokoscOdsetekNaDzien,
            label = "Wysokość odsetek pozostałych do wyegzekwowania na dzień sporządzenia zawiadomienia"
          ))
          add(ezwComponents.amountField(//Text: wysokoscKosztow "Wysokość kosztów upomnienia pozostałych do wyegzekwowania na dzień sporządzenia zawiadomienia"
            field = blokDWewnetrzny.inneZdarzenie.wysokoscKosztow,
            label = "Wysokość kosztów upomnienia pozostałych do wyegzekwowania na dzień sporządzenia zawiadomienia",
            required = false
          ))
          add(ezwComponents.amountField(//Text: wysokoscOdsetekNiezaplacenie "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej w terminie naliczonych na dzień wystawienia tytułu wykonawczego od zmniejszonej w wyniku wyegzekwowania wysokości należności pieniężnej"
            field = blokDWewnetrzny.inneZdarzenie.wysokoscOdsetekNiezaplacenie,
            label = "Wysokość odsetek z tytułu niezapłacenia należności pieniężnej w terminie naliczonych na dzień wystawienia tytułu wykonawczego od zmniejszonej w wyniku wyegzekwowania wysokości należności pieniężnej"
          ))
        })
      }

      add(
        Select( //Select: powodZmianyWysokosciNaleznosciLubKosztowUpomnienia "PowĂłd zmiany wysokoĹ›ci naleĹĽnoĹ›ci lub kosztĂłw upomnienia" listOfReasonsForChangeInReceivablesOrNotificationCost
          value = blokDWewnetrzny.powodZmianyWysokosciNaleznosciLubKosztowUpomnienia,
          label = "Powód zmiany wysokości należności lub kosztów upomnienia"
        ).apply {
          onEvent {
            change = {
              blokDWewnetrzny.powodZmianyWysokosciNaleznosciLubKosztowUpomnienia = self.value
              when (self.value) {
                "Wyegzekwowanie" -> {//"1. Wyegzekwowania naleĹĽnoĹ›ci pieniÄ™ĹĽnej przez inny organ egzekucyjny", // Wyegzekwowanie
                  wyegzekwowanie.show()
                  korekta.hide()
                  przedawnienie.hide()
                  zaplata.hide()
                  inneZdarzenie.hide()
                }
                "Korekta" -> {//"2. Korekty deklaracji/zeznania powodujÄ…cej zmniejszenie wysokoĹ›ci naleĹĽnoĹ›ci pieniÄ™ĹĽnej", //Korekta
                  wyegzekwowanie.hide()
                  korekta.show()
                  przedawnienie.hide()
                  zaplata.hide()
                  inneZdarzenie.hide()
                }
                "Przedawnienie" -> {//"3. Przedawnienia naleĹĽnoĹ›ci pieniÄ™ĹĽnej", //Przedawnienie
                  wyegzekwowanie.hide()
                  korekta.hide()
                  przedawnienie.show()
                  zaplata.hide()
                  inneZdarzenie.hide()
                }
                "Zaplata" -> {//"4. ZapĹ‚aty wierzycielowi naleĹĽnoĹ›ci pieniÄ™ĹĽnej", //Zaplata
                  wyegzekwowanie.hide()
                  korekta.hide()
                  przedawnienie.hide()
                  zaplata.show()
                  inneZdarzenie.hide()
                }
                "InneZdarzenie" -> {//"5. Inne zdarzenia skutkujÄ…ce zmniejszeniem wysokoĹ›ci naleĹĽnoĹ›ci", //InneZdarzenie->{
                  wyegzekwowanie.hide()
                  korekta.hide()
                  przedawnienie.hide()
                  zaplata.hide()
                  inneZdarzenie.show()
                }
              }
            }
          }
          for ((key, value) in EzwData.listOfReasonsForChangeInReceivablesOrNotificationCost) {
            selectOption(value = key.toString(), label = value)
            liveSearch = true
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        }
      )
      add(wyegzekwowanie)
      add(korekta)
      add(przedawnienie)
      add(zaplata)
      add(inneZdarzenie)
    }
  }

  val blokE: (BlokE, String?) -> FieldsetPanel = { blokE , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(FieldsetPanel("Nastąpiła przesłanka do zawieszenia postępowania").apply {
        var wCzesci = FieldsetPanel("W części").apply {
          visible = blokE.przeslankaDoZawieszeniaPostepowania == "1" //w części
          add(ezwComponents.fieldsetPanelDataOkres(
            field = blokE.wCzesci.dataOkresPowstaniaNaleznosci,
            label = "Data/okres powstania należności pieniężnej"
          ))
          add(ezwComponents.amountField(//Text: wysokoscZawieszonejNaleznosci "Wysokość zawieszonej należności"
            field = blokE.wCzesci.wysokoscZawieszonejNaleznosci,
            label = "Wysokość zawieszonej należności"
          ))
          add(ezwComponents.amountField(//Text: wysokoscPozostalejNaleznosci "Należność pozostała do wyegzekwowania"
            field = blokE.wCzesci.wysokoscPozostalejNaleznosci,
            label = "Należność pozostała do wyegzekwowania"
          ))
        }
        add(dynamicFieldsValidator.add( //Select: "Przesłanka do zawieszenia postępowania" listOfReasonPartOptions
          Select(
            value = blokE.przeslankaDoZawieszeniaPostepowania,
            label = "Przesłanka do zawieszenia postępowania"
          ).apply {
            emptyOption = true
            onEvent {
              change = {
                blokE.przeslankaDoZawieszeniaPostepowania = self.value
                if (blokE.przeslankaDoZawieszeniaPostepowania == "1") {
                  wCzesci.show()
                } else {
                  wCzesci.hide()
                }
              }
            }
            for ((key, value) in EzwData.listOfReasonPartOptions.withIndex()) {
              selectOption(value = key.toString(), label = value)
              liveSearch = true
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE
        ))
        add(wCzesci)
      })
      add(ezwComponents.fieldsetPanelDataOkres(
        field = blokE.dataOkresPodstawyPrawnej,
        label = "Data/okres zawieszenia postępowania"
      ))
      add(dynamicFieldsValidator.add( //Text: podstawaPrawnaZawieszenia "Przesłanka zawieszenia postępowania"
        Text(
          value = blokE.podstawaPrawnaZawieszenia,
          label = "Przesłanka zawieszenia postępowania"
        ).apply {
          onEvent {
            change = {
              blokE.podstawaPrawnaZawieszenia = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      add(//Text: uwagi "Uwagi wierzyciela" //opcjonalne
        Text(
          value = blokE.uwagi,
          label = "Uwagi wierzyciela"
        ).apply {
          onEvent {
            change = {
              blokE.uwagi = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
    }
  }

  val blokF: (BlokF, String?) -> FieldsetPanel = { blokF , elementsName ->
    FieldsetPanel(elementsName).apply {
      val validationGroup = "przeslankaDoPodjeciaZawieszonegoPostepowania" + Util.getRandomString()
      var blokFDataOkresPowstaniaNaleznosci = ezwComponents.fieldsetPanelDataOkres(
        field = blokF.dataOkresPowstaniaNaleznosci,
        label = "Data/okres powstania należności pieniężnej",
        validationGroup = validationGroup
      )
      if (blokF.przeslankaDoPodjeciaZawieszonegoPostepowania == "0") {
        dynamicFieldsValidator.addNotValidationGroup(validationGroup)
        (blokFDataOkresPowstaniaNaleznosci.getChildren().get(0) as DateTime).flabel.removeCssClass("required-label")
        (blokFDataOkresPowstaniaNaleznosci.getChildren().get(0) as DateTime).validatorError = null
        console.log("add przeslanka F poczatek")
      }
      add(dynamicFieldsValidator.add( //Select: "Przesłanka do podjęcia zawieszonego postępowania" listOfReasonPartOptions
        Select(
          value = blokF.przeslankaDoPodjeciaZawieszonegoPostepowania,
          label = "Przesłanka do podjęcia zawieszonego postępowania"
        ).apply {
          emptyOption = true
          onEvent {
            change = {
              blokF.przeslankaDoPodjeciaZawieszonegoPostepowania = self.value
              if (blokF.przeslankaDoPodjeciaZawieszonegoPostepowania == "1") {
                console.log("remove przeslanka F")
                dynamicFieldsValidator.removeNotValidationGroup(validationGroup)
                (blokFDataOkresPowstaniaNaleznosci.getChildren().get(0) as DateTime).flabel.addCssClass("required-label")
                (blokFDataOkresPowstaniaNaleznosci.getChildren().get(0) as DateTime).validatorError = null
              } else {
                console.log("add przeslanka F")
                dynamicFieldsValidator.addNotValidationGroup(validationGroup)
                (blokFDataOkresPowstaniaNaleznosci.getChildren().get(0) as DateTime).flabel.removeCssClass("required-label")
                (blokFDataOkresPowstaniaNaleznosci.getChildren().get(0) as DateTime).validatorError = null
              }
            }
          }
          for ((key, value) in EzwData.listOfReasonPartOptions.withIndex()) {
            selectOption(value = key.toString(), label = value)
            liveSearch = true
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      add(blokFDataOkresPowstaniaNaleznosci)

      add(ezwComponents.dateField(//Text: dataPodjecia "Data, od której należy podjąć zawieszone postępowanie"
        field = blokF.dataPodjecia,
        label = "Data, od której należy podjąć zawieszone postępowanie"
      ))
      add(FieldsetPanel("Informacja o należności pieniężnej pozostałej do wyegzekwowania").apply { //InformacjaONaleznosci
        add(ezwComponents.amountField(//Text: wysokoscPozostalejNaleznosci "Wysokość należności pieniężnej"
          field = blokF.informacjaONaleznosci.wysokoscPozostalejNaleznosci,
          label = "Wysokość należności pieniężnej"
        ))
        add(ezwComponents.amountField(//Text: wysokoscOdsetekNaDzien "Wysokość odsetek na dzień sporządzenia zawiadomienia"
          field = blokF.informacjaONaleznosci.wysokoscOdsetekNaDzien,
          label = "Wysokość odsetek na dzień sporządzenia zawiadomienia"
        ))
        add(ezwComponents.amountField(//Text: wysokoscKosztow "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia"
          field = blokF.informacjaONaleznosci.wysokoscKosztow,
          label = "Wysokość kosztów upomnienia na dzień sporządzenia zawiadomienia",
          required = false
        ))
      })

      add(dynamicFieldsValidator.add( //Text: zdarzeniePodjecia "Przesłanka ustania przyczyny zawieszenia"
        Text(
          value = blokF.zdarzeniePodjecia,
          label = "Przesłanka ustania przyczyny zawieszenia"
        ).apply {
          onEvent {
            change = {
              blokF.zdarzeniePodjecia = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      add(//Text: uwagi "Uwagi wierzyciela" //opcjonalne
        Text(
          value = blokF.uwagi,
          label = "Uwagi wierzyciela"
        ).apply {
          onEvent {
            change = {
              blokF.uwagi = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
    }
  }

  val blokG: (BlokG, String?) -> FieldsetPanel = { blokG , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(ezwComponents.dateField(//Text: dataUmorzenia "Data zaistnienia przesłanki do umorzenia postępowania"
        field = blokG.dataUmorzenia,
        label = "Data zaistnienia przesłanki do umorzenia postępowania"
      ))
      var wCzesci = FieldsetPanel("W części").apply {
        add(ezwComponents.fieldsetPanelDataOkres(
          field = blokG.wCzesci.dataOkresPowstaniaNaleznosci,
          label = "Data/okres powstania należności pieniężnej"
        ))
        add(ezwComponents.amountField(//Text: wysokoscZawieszonejNaleznosci "Wysokość zawieszonej należności"
          field = blokG.wCzesci.wysokoscZawieszonejNaleznosci,
          label = "Wysokość zawieszonej należności"
        ))
        add(ezwComponents.amountField(//Text: wysokoscPozostalejNaleznosci "Należność pozostała do wyegzekwowania"
          field = blokG.wCzesci.wysokoscPozostalejNaleznosci,
          label = "Należność pozostała do wyegzekwowania"
        ))
      }
      add(dynamicFieldsValidator.add( //Select: umorzeniePostepowaniaEgzekucyjnego "Umorzenie postępowania egzekucyjnego" listOfReasonPartOptions
        Select(
          value = blokG.umorzeniePostepowaniaEgzekucyjnego,
          label = "Umorzenie postępowania egzekucyjnego"
        ).apply {
          emptyOption = true
          onEvent {
            change = {
              blokG.umorzeniePostepowaniaEgzekucyjnego = self.value
              if (blokG.umorzeniePostepowaniaEgzekucyjnego == "1") {
                wCzesci.show()
              } else {
                wCzesci.hide()
              }
            }
          }
          for ((key, value) in EzwData.listOfReasonPartOptions.withIndex()) {
            selectOption(value = key.toString(), label = value)
            liveSearch = true
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      add(wCzesci)

      add(dynamicFieldsValidator.add( //Text: przeslankaUmorzenia "Przesłanka umorzenia postępowania"
        Text(
          value = blokG.przeslankaUmorzenia,
          label = "Przesłanka umorzenia postępowania"
        ).apply {
          onEvent {
            change = {
              blokG.przeslankaUmorzenia = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      add(//Text: uwagi "Uwagi wierzyciela" //opcjonalne
        Text(
          value = blokG.uwagi,
          label = "Uwagi wierzyciela"
        ).apply {
          onEvent {
            change = {
              blokG.uwagi = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
    }
  }

  val blokH: (BlokH, String?) -> FieldsetPanel = { blokH , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(ezwComponents.fieldsetPanelDataOkres(
        field = blokH.dataOkresPowstaniaNaleznosci,
        label = "Data/okres powstania należności pieniężnej"
      ))
      add(ezwBlockList.generateModifiableList(
        blokH.nienaliczanieOdsetekList,
        blokHNienaliczanieOdsetek,
        :: NienaliczanieOdsetek,
        "Okresy nienaliczania odsetek",
        { iter -> "Okres $iter" }
      ))

    }
  }

  val blokHNienaliczanieOdsetek: (NienaliczanieOdsetek, String?) -> FieldsetPanel = { blokHNienaliczanieOdsetek , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(FieldsetPanel("Nienaliczanie odsetek").apply {
        add(ezwComponents.fieldsetPanelDataOkres(
          field = blokHNienaliczanieOdsetek.okresNienaliczania,
          label = "Data/okres nienaliczania odsetek"
        ))
        add(//Text: przyczynaNienaliczania "Przyczyna nienaliczania odsetek"
          Text(
            value = blokHNienaliczanieOdsetek.przyczynaNienaliczania,
            label = "Przyczyna nienaliczania odsetek"
          ).apply {
            onEvent {
              change = {
                blokHNienaliczanieOdsetek.przyczynaNienaliczania = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          }
        )
      })
    }
  }

  val blokH1: (BlokH1, String?) -> FieldsetPanel = { blokH1 , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(ezwComponents.fieldsetPanelDataOkres(
        field = blokH1.dataOkresPowstaniaNaleznosci,
        label = "Data/okres powstania należności pieniężnej"
      ))
      add(ezwComponents.dateField(//Text: dzienNienaliczania "Dzień, od którego nie nalicza się odsetek"
        field = blokH1.dzienNienaliczania,
        label = "Dzień, od którego nie nalicza się odsetek")
      )
      add(//Text: przedmiotZabezpieczenia "Przedmiot zabezpieczenia, z którego można dochodzić należności" //opcjonalne
        Text(
          value = blokH1.przedmiotZabezpieczenia,
          label = "Przedmiot zabezpieczenia, z którego można dochodzić należności"
        ).apply {
          onEvent {
            change = {
              blokH1.przedmiotZabezpieczenia = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
    }
  }

  val blokI: (BlokI, String?) -> FieldsetPanel = { blokI , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(dynamicFieldsValidator.add( //Select: rodzajPodmiotu "Podmiot biorący udział w postępowaniu" listOfEntityTypes
        Select(
          value = blokI.rodzajPodmiotu,
          label = "Podmiot biorący udział w postępowaniu"
        ).apply {
          emptyOption = true
          onEvent {
            change = {
              blokI.rodzajPodmiotu = self.value
            }
          }
          for ((key, value) in EzwData.listOfEntityTypes) {
            selectOption(value = key.toString(), label = value)
            liveSearch = true
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      var dlaOsobyFizycznej = Div().apply {
        visible = blokI.czyOsobaFizyczna
        add(dynamicFieldsValidator.add( //Text: imie "Imie" // Imie w przypadku osoby fizycznej
          Text( //VALIDATION TImie ( MAX 30)
            value = blokI.imie,
            label = "Imie"
          ).apply {
            onEvent {
              change = {
                blokI.imie = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE
        ))
        add(dynamicFieldsValidator.add( //Text: nazwisko "Nazwisko" // Nazwisko w przypadku osoby fizycznej
          Text(
            value = blokI.nazwisko,
            label = "Nazwisko"
          ).apply {
            onEvent {
              change = {
                blokI.nazwisko = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE
        ))
      }
      var dlaPodmiotu = Div().apply {
        visible = !blokI.czyOsobaFizyczna
        add(dynamicFieldsValidator.add( //Text: nazwa "Nazwa" // Nazwa w przypadku podmiotu
          Text(
            value = blokI.nazwa,
            label = "Nazwa"
          ).apply {
            onEvent {
              change = {
                blokI.nazwa = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
            flabel.addCssClass("required-label")
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE
        ))
      }
      add(CheckBox(//Checkbox: czyOsobaFizyczna
        value = blokI.czyOsobaFizyczna,
        label = "Osoba Fizyczna",
        rich = true
      ).apply {
        onEvent {
          change = {
            blokI.czyOsobaFizyczna = self.value
            if (self.value) {
              dlaOsobyFizycznej.show()
              dlaPodmiotu.hide()
            } else {
              dlaOsobyFizycznej.hide()
              dlaPodmiotu.show()
            }
          }
        }
      })
      add(dlaOsobyFizycznej)
      add(dlaPodmiotu)

      add(ezwComponents.fieldsetPanelAdres(blokI.adres))
      add(dynamicFieldsValidator.add( //Text: nrTelefonu "Numer telefonu" //opcjonalne
        Text(
          value = blokI.nrTelefonu,
          label = "Numer telefonu"
        ).apply {
          onEvent {
            change = {
              blokI.nrTelefonu = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },
        { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("\\+?[0-9]+([- ][0-9]+)*")?.toRegex()?.matches(elem) == true) },
        "Niepoprawny numer telefonu"
      )) //arrayOf("\\+?[0-9]+([- ][0-9]+)*", "Niepoprawny numer telefonu")

      add(dynamicFieldsValidator.add( //Text: email "Email" //opcjonalne
        Text(
          value = blokI.email,
          label = "Email"
        ).apply {
          onEvent {
            change = {
              blokI.email = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },
        { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")?.toRegex()?.matches(elem) == true) },
        "Adres e-mail jest niepoprawny"
      ))//"^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$", "Adres e-mail jest niepoprawny"

      add(dynamicFieldsValidator.add( //Text: skrytkaEPuap "Adres skrzynki ePUAP" //opcjonalne
        Text(
          value = blokI.skrytkaEPuap,
          label = "Adres skrzynki ePUAP"
        ).apply {
          onEvent {
            change = {
              blokI.skrytkaEPuap = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },//arrayOf("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}", "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\"")
        { elem -> ((elem.isNullOrEmpty() || elem.isBlank()) || ("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}")?.toRegex()?.matches(elem) == true) },
        "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\""
      ))
    }
  }

  val blokJ: (BlokJ, String?) -> FieldsetPanel = { blokJ , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(dynamicFieldsValidator.add( //Text: treśćInformacji  "Treść informacji "
        Text(
          value = blokJ.treśćInformacji,
          label = "Treść informacji"
        ).apply {
          onEvent {
            change = {
              blokJ.treśćInformacji = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
    }
  }

  val blokK: (BlokK, String?) -> FieldsetPanel = { blokK , elementsName ->
    FieldsetPanel(elementsName).apply {
      add(dynamicFieldsValidator.add( //Text: organZawiadomionyPrzezWierzyciela "Organ zawiadomiony przez wierzyciela"
        Text(
          value = blokK.organZawiadomionyPrzezWierzyciela,
          label = "Organ zawiadomiony przez wierzyciela"
        ).apply {
          onEvent {
            change = {
              blokK.organZawiadomionyPrzezWierzyciela = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
    }
  }

  val blokTrescZawiadomienia: (TrescZawiadomienia, String?) -> FieldsetPanel = { trescZawiadomienia, elementsName ->
    FieldsetPanel(elementsName).apply {

      //C (zawsze dla 3)
      add(blokC(
        trescZawiadomienia.blokC,
        "BLOK C - INFORMACJA O TYTULE WYKONAWCZYM/ZARZĄDZENIU ZABEZPIECZENIA"
      ))
      //D (opcjonalny dla 3)
      add(blokD(
        trescZawiadomienia.blokD,
        "BLOK D - ZMIANA WYSOKOŚCI NALEŻNOŚCI/KOSZTÓW UPOMNIENIA JEST WYNIKIEM:"
      ))

      add(FieldsetPanel("SEKCJA WSPÓLNA BLOKÓW E, F i G").apply {
        //E (opcjonalny dla 3)
        val blokEList = ezwBlockList.generateModifiableList(
          trescZawiadomienia.blokEFG.blokEList,
          blokE,
          ::BlokE,
          "BLOK E - WNIOSEK O ZAWIESZENIE POSTĘPOWANIA EGZEKUCYJNEGO/ZABEZPIECZAJĄCEGO",
          { iter -> "E$iter." }
        )
        //F (opcjonalny dla 3)
        val blokFList = ezwBlockList.generateModifiableList(
          trescZawiadomienia.blokEFG.blokFList,
          blokF,
          :: BlokF,
          "BLOK F - WNIOSEK O PODJĘCIE ZAWIESZONEGO POSTĘPOWANIA",
          { iter -> "F$iter." }
        )
        //G (opcjonalny dla 3)
        val blokGList = ezwBlockList.generateModifiableList(
          trescZawiadomienia.blokEFG.blokGList,
          blokG,
          :: BlokG,
          "BLOK G - WNIOSEK O UMORZENIE POSTĘPOWANIA EGZEKUCYJNEGO/ZABEZPIECZAJĄCEGO",
          { iter -> "G$iter." }
        )

        add(
          RadioGroup(
            options = EzwData.listOfBlocksEFG,
            value = trescZawiadomienia.blokEFG.rodzajBloku,
            label = "Wybierz jeden z dostępnych rodzajów bloków, dla danego dokumentu",
            inline = true
          ).apply {
            onEvent {
              change = {
                trescZawiadomienia.blokEFG.rodzajBloku = self.value
                visibilityBlocksEFG(
                  blokEList,
                  blokFList,
                  blokGList,
                  self.value
                )
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
            flabel.addCssClass("required-label")
          }
        )
        visibilityBlocksEFG(
          blokEList,
          blokFList,
          blokGList,
          trescZawiadomienia.blokEFG.rodzajBloku
        )
        add(blokEList)
        add(blokFList)
        add(blokGList)
      })

      //H (opcjonalny dla 3)
      add(ezwBlockList.generateModifiableList(
        trescZawiadomienia.blokHList,
        blokH,
        :: BlokH,
        "BLOK H - OKRES NIENALICZANIA ODSETEK",
        { iter -> "H$iter." }
      ))
      //H1 (opcjonalny dla 3)
      add(ezwBlockList.generateModifiableList(
        trescZawiadomienia.blokH1List,
        blokH1,
        :: BlokH1,
        "BLOK H1 - OKRES NIENALICZANIA ODSETEK W WYNIKU PRZEDAWNIENIA SIĘ NALEŻNOŚCI ZABEZPIECZONEJ",
        { iter -> "Okres $iter" }
      ))

      //I (opcjonalny dla 2 i 3)
      add(ezwBlockList.generateModifiableList(
        trescZawiadomienia.blokIList,
        blokI,
        :: BlokI,
        "BLOK I - DANE PODMIOTU / PODMIOTÓW BIORĄCYCH UDZIAŁ W POSTĘPOWANIU EGZEKUCYJNYM/ZABEZPIECZAJĄCYM",
        { iter -> "I$iter." }
      ))
      //J (opcjonalny dla 2 i 3)
      add(ezwBlockList.generateModifiableList(
        trescZawiadomienia.blokJList,
        blokJ,
        :: BlokJ,
        "BLOK J - POZOSTAŁE INFOMACJE O ZOBOWIĄZANYM/ZOBOWIĄZANYCH",
        { iter -> "J$iter." }
      ))
      //K (opcjonalny dla 2 i 3)
      add(ezwBlockList.generateModifiableList(
        trescZawiadomienia.blokKList,
        blokK,
        :: BlokK,
        "BLOK K - ZAWIADOMIENIE INNEGO ORGANU PRZEZ WIERZYCIELA",
        { iter -> "K$iter." }
      ))

    }
  }

  private fun visibilityBlocksEFG(
    blokEList: FieldsetPanel,
    blokFList: FieldsetPanel,
    blokGList: FieldsetPanel,
    rodzajBloku: String?
  ) {
    if(rodzajBloku == "blokE"){
      blokEList.show()
      blokFList.hide()
      blokGList.hide()
    }
    if(rodzajBloku == "blokF"){
      blokEList.hide()
      blokFList.show()
      blokGList.hide()
    }
    if(rodzajBloku == "blokG"){
      blokEList.hide()
      blokFList.hide()
      blokGList.show()
    }
    if(rodzajBloku == null){
      blokEList.hide()
      blokFList.hide()
      blokGList.hide()
    }
  }

  val blokZobowiazanego: (
    ArrayList<BlokI>,
    ArrayList<BlokJ>,
    ArrayList<BlokK>
  ) -> Div = {
    blokIList,
    blokJList,
    blokKList ->
    Div().apply {
      //I (opcjonalny dla 2 i 3)
      add(ezwBlockList.generateModifiableList(
        blokIList,
        blokI,
        :: BlokI,
        "BLOK I - DANE PODMIOTU / PODMIOTÓW BIORĄCYCH UDZIAŁ W POSTĘPOWANIU EGZEKUCYJNYM/ZABEZPIECZAJĄCYM",
        { iter -> "I$iter." }
      ))
      //J (opcjonalny dla 2 i 3)
      add(ezwBlockList.generateModifiableList(
        blokJList,
        blokJ,
        :: BlokJ,
        "BLOK J - POZOSTAŁE INFOMACJE O ZOBOWIĄZANYM/ZOBOWIĄZANYCH",
        { iter -> "J$iter." }
      ))
      //K (opcjonalny dla 2 i 3)
      add(ezwBlockList.generateModifiableList(
        blokKList,
        blokK,
        :: BlokK,
        "BLOK K - ZAWIADOMIENIE INNEGO ORGANU PRZEZ WIERZYCIELA",
        { iter -> "K$iter." }
      ))
    }
  }
}
